import { createFileRoute } from "@tanstack/react-router";
import AppointmentSuccess from "@/pages/AppointmentSuccess";
import { getPageUrl } from "@/lib/site";

export const Route = createFileRoute("/appointment/$ref")({
  head: ({ params }) => {
    const pageUrl = getPageUrl(
      `/appointment/${encodeURIComponent(params.ref)}`
    );

    return {
      meta: [
        { title: `Appointment Confirmed · ${params.ref} | KNMC` },
        { name: "robots", content: "noindex" },
        {
          property: "og:title",
          content: `Appointment Confirmed · ${params.ref} | KNMC`,
        },
        {
          property: "og:url",
          content: pageUrl,
        },
      ],
      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: AppointmentSuccess,
});